import { useMutation } from "@tanstack/react-query";
import { useRestClient } from "../../api/RestClientContext";

export function useCreateSubscription() {
    const client = useRestClient();

    const mutation = useMutation({
        mutationFn: (ref?: string) => client.createSubscription(ref),
        onError: (error) => {
            console.error("Ошибка при создании подписки:", error);
        }
    });

    return {
        sub: mutation.data,
        createSubscription: mutation.mutate,
        createSubscriptionAsync: mutation.mutateAsync,
        isLoading: mutation.isPending,
        error: mutation.error,
    };
}